// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

// Define a service using a base URL and expected endpoints
export const apInformationDocsListAPI = createApi({
  reducerPath: "apInformationDocsListAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ["apInformationDocs"],
  endpoints: (builder) => ({
    getAPInformationDocsList: builder.query<any, apInformationArgTypes>({
      query: ({ apCode, year }) => ({
        url: `/am/ap/${apCode}/actionplans/year/${year}`,
        method: "GET",
      }),
      providesTags: ["apInformationDocs"],
    }),
    deleteAPInformationDoc: builder.mutation<any, ABOSuccessionIdType>({
      query: ({ id }) => ({
        url: `/am/ap/actionplan/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["apInformationDocs"],
    }),
    uploadAPInformationDocs: builder.mutation<any, UploadApInfoDocArgTypes>({
      query: ({ apCode, payload }) => ({
        url: `/am/ap/${apCode}/actionplan`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["apInformationDocs"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAPInformationDocsListQuery,
  useDeleteAPInformationDocMutation,
  useUploadAPInformationDocsMutation,
} = apInformationDocsListAPI;
